<template>
  <div style="min-width: 100%">
    <h1 class="grey--text text--darken-2">Shop in shop</h1>

    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      item-key="uitemID"
      disable-sort
      no-data-text="Shop in shop отсутствуют"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true,
      }"
      dense
      class="elevation-1 mt-5">
      <template #item.activityYear="{ item }">
        <router-link :to="'/activities/'+item.activityID" class="editable">
          {{ item.activityYear }}
        </router-link>
      </template>
      <template #item.companyName="{ item }">
        {{ item.companyName }}
        <span v-if="item.client_company_id" class="font-weight-light blue-grey--text">({{ item.clientName }})</span>
      </template>
      <template #item.unitName="{ item }">
        <span @click="if ( item.uitemID ) editAction(item)" :class="item.uitemID ? 'editable' : ''"> {{ item.uitemName ? item.uitemName : item.unitName }}</span>
      </template>
      <template #item.uitemStatus="{ item }">
        <select class="caption" @change="statusAction($event, item)">
          <option v-for="s in filtersData.statuses.filter(s => s.value != 'unaccepted')" :key="s.value" :value="s.value" v-html="s.text" :selected="s.value==item.uitemStatus"></option>
        </select>
      </template>
      <template #item.uitemPlanfixTask="{ item }">
        <span v-if="item.uitemPlanfixTask" style="color: #61a038; cursor: pointer" @click="goPlanfixAction(item.uitemPlanfixTask)">{{ item.uitemPlanfixTask }}</span>
        <span v-else class="grey--text text--lighten-1">&mdash;</span>
      </template>
    </v-data-table>

    <PlanMicrounitDialog ref="planMicrounitDialog" @updated="load()"/>
  </div>
</template>

<script>
import api from '@/api'
import { combinedObject } from '@/common.js'
import { microunitStatuses } from '@/common'

export default {
  components: {
    PlanMicrounitDialog: () => import('@/components/PlanMicrounitDialog.vue')
  },
  data: () => ({
    loading: false,
    search: '',
    headers: [
      { value: 'activityYear', text: 'Активность', width: '100', align: 'center' },
      { value: 'companyName', text: 'Контрагент' },
      { value: 'brandName', text: 'Бренд' },
      { value: 'unitName', text: 'Юнит' },
      { value: 'uitemDateStop', text: 'Истекает', width: '160' },
      { value: 'uitemStatus', text: 'Статус', align: 'left', width: '160' },
      { value: 'uitemPlanfixTask', text: 'Planfix', align: 'center', width: '100', sortable: false },
    ],
    items: [],
    filtersData: {
      statuses: microunitStatuses
    },
  }),
  mounted: function () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true;
      api.get('microunits/shopInShopList').then(response => {
        this.loading = false;
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.items = response.data.data;
//        this.items = combinedObject(response.data.data.cols, response.data.data.rows);
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    refreshAction () {
      this.load()
    },
    editAction (item) {
      this.$refs.planMicrounitDialog.edit(item)
    },
    goPlanfixAction (planfixTask) {
      window.open('https://apteka911.planfix.ua/task/'+planfixTask)
    },
    statusAction (event, item) {
      if ( event.target.value == item.uitemStatus ) return
      api.post('microunits/update/'+item.uitemID, {uitemStatus: event.target.value}).then(response => {
        this.loading = false;
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        item.uitemStatus = response.data.data.uitem.uitemStatus
        this.$root.$alert("Статус изменен")
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
  },
  filters: {
    truncate (v) { return v.length > 80 ? v.substr(0, 80)+'...' : v }
  }
}
</script>

<style scoped>
.editable { cursor: pointer; }
.editable:hover { color: #08A2B8; border-bottom: 1px #08A2B8 dashed; }
</style>
